import axios from "axios";
import moment from "moment";
import i18n from "../../../i18n";
import {
  DietDairyTypes,
  NUTRITION_FIELDS,
  dietDairyTypeToString,
} from "../DietDiary/DietDiary.constants";

//Constants
const SET_NUTRITION_VALUES = "SET_NUTRITION_VALUES";
const SET_MEAL_TOTAL_CALORIES = "SET_MEAL_TOTAL_CALORIES";
const SET_MEAL_CHARTS_HELPER = "SET_MEAL_CHARTS_HELPER";
const SET_ADD_FAVORITE_MEAL_SUCCESS = "SET_ADD_FAVORITE_MEAL_SUCCESS";
const SET_ADD_FAVORITE_MEAL_ERROR = "SET_ADD_FAVORITE_MEAL_ERROR";
const SET_NUTRITION_FIELDS = "SET_NUTRITION_FIELDS";
const SET_FOOD_DRINK_ITEMS = "SET_FOOD_DRINK_ITEMS";
const SET_ABOUT_MEAL = "SET_ABOUT_MEAL";
const SET_UPDATE_REASON_FOR = "SET_UPDATE_REASON_FOR";
const SET_DAILY_TARGETS = "SET_DAILY_TARGETS";
const RESET_STATES = "RESET_STATES";
const LOGOUT = "LOGOUT";

//Acessors
const getNutritionalInfo = (state) => state?.nutritionalInfo;
const getCalories = (state) => state?.calories;
const getChartsHelper = (state) => state?.chartsHelper;
const getIsSuccess = (state) => state?.isSuccess;
const getIsError = (state) => state?.isError;
const getNutritionFields = (state) => state?.nutritionFields;
const getSelectedItems = (state) => state?.selectedItems;
const getAboutMeal = (state) => state?.aboutMeal;
const getUpdateReasonFor = (state) => state?.updateReasonFor;
const getDailyTargets = (state) => state?.dailyTargets;

//Default state
const initialState = {
  nutritionalInfo: [],
  calories: {
    value: "0.0 kcal",
  },
  chartsHelper: {
    pieChartSeries: [],
  },
  isSuccess: false,
  isError: false,
  nutritionFields: [],
  selectedItems: [],
  aboutMeal: null,
  updateReasonFor: "",
  dailyTargets: null,
};

export const favoriteMealReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_NUTRITION_VALUES: {
      const { nutritionalInfo } = action;
      return Object.assign({}, state, {
        nutritionalInfo: nutritionalInfo,
      });
    }
    case SET_MEAL_TOTAL_CALORIES: {
      const { calories } = action;
      return Object.assign({}, state, {
        calories: calories,
      });
    }
    case SET_MEAL_CHARTS_HELPER: {
      const { chartsHelper } = action;
      return Object.assign({}, state, {
        chartsHelper: chartsHelper,
      });
    }
    case SET_ADD_FAVORITE_MEAL_SUCCESS: {
      const { isSuccess } = action;
      return Object.assign({}, state, {
        isSuccess: isSuccess,
      });
    }
    case SET_ADD_FAVORITE_MEAL_ERROR: {
      const { isError } = action;
      return Object.assign({}, state, {
        isError: isError,
      });
    }
    case SET_NUTRITION_FIELDS: {
      const { nutritionFields } = action;
      return Object.assign({}, state, {
        nutritionFields: nutritionFields,
      });
    }
    case SET_FOOD_DRINK_ITEMS: {
      const { selectedItems } = action;
      return Object.assign({}, state, {
        selectedItems: selectedItems,
      });
    }
    case SET_ABOUT_MEAL: {
      const { aboutMeal } = action;
      return Object.assign({}, state, {
        aboutMeal: aboutMeal,
      });
    }
    case SET_UPDATE_REASON_FOR: {
      const { updateReasonFor } = action;
      return Object.assign({}, state, {
        updateReasonFor: updateReasonFor,
      });
    }
    case SET_DAILY_TARGETS: {
      const { dailyTargets } = action;
      return Object.assign({}, state, {
        dailyTargets: dailyTargets,
      });
    }
    case RESET_STATES: {
      return Object.assign({}, initialState, {
        nutritionFields: state.nutritionFields,
      });
    }
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export const resetStates = () => (dispatch) => {
  return dispatch({
    type: RESET_STATES,
  });
};

export const setNutritionalInfo = (newValues) => (dispatch) => {
  return dispatch({
    type: SET_NUTRITION_VALUES,
    nutritionalInfo: newValues,
  });
};

export const setSelectedItems = (items) => (dispatch) => {
  return dispatch({
    type: SET_FOOD_DRINK_ITEMS,
    selectedItems: items,
  });
};

export const setCalories = (newValue) => (dispatch) => {
  return dispatch({
    type: SET_MEAL_TOTAL_CALORIES,
    calories: newValue,
  });
};

export const setChartsHelper = (newValue) => (dispatch) => {
  return dispatch({
    type: SET_MEAL_CHARTS_HELPER,
    chartsHelper: newValue,
  });
};

export const setIsSuccess = (newValue) => (dispatch) => {
  return dispatch({
    type: SET_ADD_FAVORITE_MEAL_SUCCESS,
    isSuccess: newValue,
  });
};

export const setIsError = (newValue) => (dispatch) => {
  return dispatch({
    type: SET_ADD_FAVORITE_MEAL_ERROR,
    isError: newValue,
  });
};

export const setAboutMeal = (newValue) => (dispatch) => {
  return dispatch({
    type: SET_ABOUT_MEAL,
    aboutMeal: newValue,
  });
};

export const setUpdateReasonFor = (newValue) => (dispatch) => {
  return dispatch({
    type: SET_UPDATE_REASON_FOR,
    updateReasonFor: newValue,
  });
};

const fetchNutritionFields = () => (dispatch) => {
  dispatch({ type: SET_NUTRITION_FIELDS, nutritionFields: NUTRITION_FIELDS });
};

const saveFavoriteMeal =
  (formData, editing, type) => async (dispatch, getState) => {
    if (editing) {
      return axios
        .put(`/api/diet/meals/favorites/edit`, formData)
        .then(() => {
          return Promise.resolve(
            `${
              type === DietDairyTypes.FOOD_DRINK
                ? i18n.t("appText.favoriteMeal")
                : dietDairyTypeToString(type)
            } ${i18n.t("appText.update.success")}!`
          );
        })
        .catch(() => {
          return Promise.reject(i18n.t("errorText.dietDiary.favorites.edit"));
        });
    } else {
      return axios
        .post(`/api/diet/meals/favorites/add`, formData)
        .then(() => {
          return Promise.resolve(
            `${
              type === DietDairyTypes.FOOD_DRINK
                ? i18n.t("appText.favoriteMeal")
                : dietDairyTypeToString(type)
            } ${i18n.t("appText.add.success")}!`
          );
        })
        .catch(() => {
          return Promise.reject(i18n.t("errorText.dietDiary.favorites.add"));
        });
    }
  };

const fetchDailyTargets = () => (dispatch) => {
  const params = {
    StartDate: moment().format("YYYY/MM/DDT00:00:00"),
  };

  return axios
    .get(`/api/diet/meals`, { params })
    .then(({ data }) => {
      dispatch({ type: SET_DAILY_TARGETS, dailyTargets: data?.dailyTargets });
    })
    .catch(() => {
      return Promise.reject(i18n.t("errorText.dietDiary.dailyTargets.get"));
    });
};

export const mapStateToProps = (state) => {
  return {
    nutritionalInfo: getNutritionalInfo(state),
    calories: getCalories(state),
    chartsHelper: getChartsHelper(state),
    isSuccess: getIsSuccess(state),
    isError: getIsError(state),
    nutritionFields: getNutritionFields(state),
    selectedItems: getSelectedItems(state),
    aboutMeal: getAboutMeal(state),
    updateReasonFor: getUpdateReasonFor(state),
    dailyTargets: getDailyTargets(state),
  };
};

export const mapDispatchToProps = {
  setNutritionalInfo,
  setSelectedItems,
  setCalories,
  setChartsHelper,
  setIsSuccess,
  setIsError,
  setAboutMeal,
  setUpdateReasonFor,
  saveFavoriteMeal,
  fetchNutritionFields,
  fetchDailyTargets,
  resetStates,
};
